// extracted by mini-css-extract-plugin
module.exports = {"input_label":"Upload_input_label_1mZ8P","preview":"Upload_preview_2IbRh","submit_button":"Upload_submit_button_3YRLI","el_button":"Upload_el_button_2m5_9"};